import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { GlobalLoaderService } from '@core/services/global-loader.service';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-global-loader',
    templateUrl: './global-loader.component.html',
    styleUrls: ['./global-loader.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class GlobalLoaderComponent implements OnInit {
  static readonly componentName = 'GlobalLoaderComponent';
  
  isLoading$: Observable<boolean>;
  constructor(private globalLoaderService: GlobalLoaderService) {}

  ngOnInit() {
    this.isLoading$ = this.globalLoaderService.isLoading$;
  }
}
